export default __webpack_public_path__ + "33048a08960488fefa1beab843032cdb.png";